import React from 'react';

export default function Legend({ className = '' }) {
  return (
    <div
      className={`flex items-center gap-8 text-sm font-poppins text-[#2B3133] ${className}`}
    >
      <div className="flex items-center gap-2">
        <span
          className="inline-block w-2.5 h-2.5 rounded-full"
          style={{ background: '#FF5959' }}
        />
        <span>Attention</span>
      </div>
      <div className="flex items-center gap-2">
        <span
          className="inline-block w-2.5 h-2.5 rounded-full"
          style={{ background: '#71C0D6' }}
        />
        <span>Ok</span>
      </div>
      <div className="flex items-center gap-2">
        <span
          className="inline-block w-2.5 h-2.5 rounded-full"
          style={{ background: '#119975' }}
        />
        <span>Optimal</span>
      </div>
    </div>
  );
}
